import { createServerFn } from "@tanstack/react-start"
import { z } from "zod"
import { requireInventoryUserId } from "../lib/auth.server"
import {
  createProduct,
  listProducts,
  updateProduct,
} from "../lib/products.server"

const productTypeSchema = z.enum(["sim", "device"])

export const listProductsFn = createServerFn({ method: "GET" })
  .validator(
    (data?: { includeInactive?: boolean; type?: "sim" | "device" }) => data,
  )
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return listProducts(data)
  })

export const createProductFn = createServerFn({ method: "POST" })
  .validator((data: unknown) =>
    z
      .object({
        type: productTypeSchema,
        name: z.string(),
        brand: z.string().nullable().optional(),
        model: z.string().nullable().optional(),
        defaultCarrierId: z.number().nullable().optional(),
      })
      .parse(data),
  )
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return createProduct(data)
  })

export const updateProductFn = createServerFn({ method: "POST" })
  .validator((data: unknown) =>
    z
      .object({
        id: z.number(),
        name: z.string().optional(),
        brand: z.string().nullable().optional(),
        model: z.string().nullable().optional(),
        defaultCarrierId: z.number().nullable().optional(),
        isActive: z.boolean().optional(),
      })
      .parse(data),
  )
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return updateProduct(data)
  })
